import { render, staticRenderFns } from "./payment-list-charts.vue?vue&type=template&id=952ddaa8&scoped=true"
import script from "./payment-list-charts.vue?vue&type=script&lang=js"
export * from "./payment-list-charts.vue?vue&type=script&lang=js"
import style0 from "./payment-list-charts.vue?vue&type=style&index=0&id=952ddaa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952ddaa8",
  null
  
)

export default component.exports